import { Pipe, PipeTransform } from '@angular/core';

/** emjio.svg sprite 是否已注入 document(模块级内存单例,只 inject 一次) */
let spriteInjected = false;

/**
 * 消息标签/类型 → fl-icon name Pipe
 *
 * 把接口返回的语义名映射为 emjio.svg 内嵌 symbol 名(供 <lib-fl-icon [name]> 引用)：
 * 不懂/疑问→疑问；我来讲→举手；听懂了→听懂了；感谢→感谢
 *
 * 标签接口返回「不懂」、messageType 枚举返回「疑问」，两者同义，都映射到「疑问」symbol；
 * 未命中映射时返回空串，图标会静默空白。
 *
 * 首次被调用时把 emjio.svg 注入到 body —— <use>#id 只能引用同一文档内的 symbol,
 * sprite 未注入则图标渲染空白。
 */
@Pipe({
  name: 'emjioIconName',
  standalone: true,
})
export class EmjioIconNamePipe implements PipeTransform {
  private static readonly SYMBOL_MAP: Record<string, string> = {
    不懂: '疑问',
    疑问: '疑问',
    我来讲: '举手',
    听懂了: '听懂了',
    感谢: '感谢',
  };

  transform(tag: string | undefined): string {
    ensureEmjioSprite();
    return EmjioIconNamePipe.SYMBOL_MAP[tag ?? ''] ?? '';
  }
}

/** 把 emjio.svg 注入 document;injected flag 防重复 fetch */
function ensureEmjioSprite() {
  if (spriteInjected) return;
  spriteInjected = true;
  fetch('/assets/svg/emjio.svg')
    .then(r => {
      if (!r.ok) throw new Error(`加载 emjio.svg 失败: ${r.status}`);
      return r.text();
    })
    .then(html => document.body.insertAdjacentHTML('beforeend', html))
    .catch(() => {
      // 加载失败时重置 flag,允许后续重试(避免网络抖动后图标永久缺失)
      spriteInjected = false;
    });
}
